import { useCallback } from 'react';
import { Modal, message } from 'antd';
import { pwg208Api, FG160 } from '../../../services/pwg208Api';

interface UsePWG208ApprovalOptions {
  record: FG160 | null;
  isEditing: boolean;
  loadRecord: (id: string) => Promise<void>;
}

// PWG208 送審 (PWG208-ACT-SUBMIT) — Modal.confirm gesture mirrors
// useD202Approval's handleSubmitClick (CHAIN-17 前端棒, 2026-07-23). No
// request body: isFinanceUser is resolved server-side from the caller's
// auth context, not a client-supplied confirmed flag (handler.go's Submit
// never calls ShouldBindJSON).
export function usePWG208Approval({ record, isEditing, loadRecord }: UsePWG208ApprovalOptions) {
  const handleSubmitClick = useCallback(() => {
    if (!record || isEditing) return;
    Modal.confirm({
      title: '確認送審',
      content: `確定要將開票申請單 ${record.fg160_01} 送審？`,
      okText: '送審',
      cancelText: '取消',
      onOk: async () => {
        try {
          await pwg208Api.submit(record.fg160_01);
          message.success('送審成功');
          await loadRecord(record.fg160_01);
        } catch (err: unknown) {
          const e = err as { response?: { data?: { error?: string } } };
          message.error(e.response?.data?.error || '送審失敗');
        }
      },
    });
  }, [record, isEditing, loadRecord]);

  return { handleSubmitClick };
}
